import React from 'react';

import styles from './index.less';

const ScrollTips = () => {
  return <img className={styles.scroll_tips} src={require('./images/page-scroll-tips.png')} alt="滚动提示" draggable={false} />;
};

export default ScrollTips;
